module.exports = __webpack_public_path__ + "d31538d695f5160f65fe0c45c7bf1807.ttf";